import * as React from "react";
import { DrawdownType } from "../../../../../../../Wrap/Constants/Enums/Drawdown/DrawdownType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CurrencyCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { PensionArrangementType } from "../../../../../../../Wrap/Constants/Enums/Domain/PensionArrangementType";
import { CappedFlexiSection } from "../../../Common/SIPP/IncomePaymentDetails/CappedFlexiSection";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { FlexiModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/FlexiModel";
import { calculateNetDrawdownValue } from "../../../Common/SIPP/DrawdownDetails/Helper/DrawdownDetailHelper";
import { CappedModel } from "../../../../../../../Wrap/Models/Domains/Drawdown/CappedModel";
import { DrawdownIncomeAmendmentInstruction } from "../../../../../../../Wrap/Models/Domains/Drawdown/DrawdownIncomeAmendmentInstruction";
import { findIndex } from "lodash";
import { DrawdownModel } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/DrawdownModel";
import { setValueByKey } from "../../../../../../Shared/Table/Utils/TableUtils";
import { FrequencyArraysMap, processTypeEnum } from "../../../Common/Resource/Contents";
import { Arrangements } from "../../../EditIncomeWithdrawalsWizard/Actions/Arrangements";
import { calculateAnnualIncomeAmount, calculateMaximumIncomePaymentForFlexiTarget, frequencyMap } from "../../../Common/SIPP/IncomePaymentDetails/Helper/IncomePaymentHelper";
import { getAnnualIncomeBasedOnFrequency } from "../../../GadReviewWizard/Resource/Helper";
import { Frequency } from "../../../../../../../Wrap/Constants/Enums/Domain/Frequency";

interface IIncomeFromPensionProps extends IProcessComponentProps {
    data: PensionContribution; // TODO: Since IncomeAmendment will be deleted from PensionContribution, this component should be rebuilt after that
    processType?: processTypeEnum;
    onChange: (changes) => void;
    onDrawdownIncomeAmendmentInstructionChange?: (v) => void;
}
interface IIncomeFromPensionState {
    hierachyId?: string;
}

export class IncomeFromPension extends ProcessComponent<IIncomeFromPensionProps, IIncomeFromPensionState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private onIncomeChange(changes, key?: string) {
        const { data, onChange } = this.props;
        this.onDataChange(
            (changes) => {
                this.onDataChange(onChange, changes, data, "DrawdownModel");
            },
            changes,
            data?.DrawdownModel,
            key
        );
    }

    private onIncomeReviewChange(changes) {
        const { data, onChange } = this.props;
        this.onDataChange(
            (changes) => {
                this.onDataChange(onChange, changes, data, "DrawdownIncomeReviewDetails");
            },
            changes,
            data?.DrawdownIncomeReviewDetails,
        );
    }

    private mapDrawdownIncomeToFlexiModel()
    {
        const data = this.props.data;

        if (data?.DrawdownModel?.DrawdownType === DrawdownType.Flexible) {
            const drawdownModel = data?.DrawdownModel;

            const drawdownIncome: FlexiModel = {
                PensionArrangementId: null,
                From: "Crystallisation",
                Amount: calculateNetDrawdownValue(drawdownModel, data?.PensionProtection),
                Type: "Member",
                IncomePerPayment: (drawdownModel?.Income?.AnnualAmount?.Amount?.Amount || 0) / frequencyMap[drawdownModel?.Income?.Frequency || Frequency.Monthly],
                MaximumIncomePerPayment: calculateMaximumIncomePaymentForFlexiTarget(processTypeEnum.topUpWithITFLS, null, data, true)
            };

            return drawdownIncome;
        }
        return null;

    }

    componentDidUpdate(): void {
        const { data } = this.props;
        const IncomeAmendment = data?.IncomeAmendment?.find((instruction) => instruction?.HierarchyId === data?.HierarchyId)
        if (this.state.hierachyId !== IncomeAmendment?.HierarchyId) {
            this.setState({
                hierachyId: IncomeAmendment?.HierarchyId
            })
        }
       
    }
    public render(): JSX.Element {
        const { data, processType } = this.props;

        const arrangements: Arrangements = {
            CappedModels: data?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.CappedArrangements || [],
            FlexiModels: data?.DrawdownIncomeAmendmentModel?.DrawdownIncomeAmendmentInstruction?.FlexiArrangements || []
        }

        return (
            <>
                {data?.DrawdownModel.Income?.TargetSpecificArrangements && (
                    <CappedFlexiSection
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        onRef={(ref) => this.appendChild(ref)}
                        income={data?.DrawdownModel?.Income}
                        onIncomeChange={(changes) => {
                            {
                                this.onIncomeChange(changes, "Income");
                            }
                        }}
                        data={arrangements}
                        drawdownType={data?.DrawdownModel?.DrawdownType}
                        onChange={(changes,type) => {
                            const convertedChanges =  type === "CappedModels" ? { CappedArrangements: changes?.CappedModels } : {FlexiArrangements: changes?.FlexiModels } ;
                            this.onDataChange(
                                (changes) => this.props.onDrawdownIncomeAmendmentInstructionChange(changes),
                                convertedChanges,
                                data?.DrawdownIncomeAmendmentModel,
                                'DrawdownIncomeAmendmentInstruction'
                            );
                        }}
                        processType={processType}
                        modelData={data?.DrawdownModel}
                        pensionProtection={data?.PensionProtection}
                        drawdownIncomeReview={data?.DrawdownIncomeReviewDetails}
                        onIncomeReviewChange={(changes) => {
                            {
                                this.onIncomeReviewChange(changes);
                            }
                        }}
                        drawdownIncomeFlexiModel={this.mapDrawdownIncomeToFlexiModel()}
                    />
                )}
            </>
        );
    }
}

export default IncomeFromPension;
